import type { InboundText } from "@/shared/inboundText.ts";
import { formatMessageTime } from "@/shared/messageTime.ts";

/**
 * One received text as a line of the conversation: who, when, and the words.
 * The words render as plain text, never markdown: someone other than the user
 * wrote them, so a link in them must not become a tap target in the thread.
 */
export const InboundTextLine = ({ text }: { text: InboundText }) => (
  <div className="flex flex-col gap-1 items-start">
    <div className="flex items-baseline gap-2 px-1 text-xs text-muted-foreground">
      <span className="font-medium text-foreground">{text.sender}</span>
      <span>{formatMessageTime(text.sentAt)}</span>
    </div>
    <div className="w-fit max-w-[75%] @md:max-w-[87%] px-5 py-3 rounded-3xl bg-muted text-sm @md:text-base whitespace-pre-wrap break-words">
      {text.words}
    </div>
  </div>
);
